
import { MutationTypes } from "@/store/mutations";
import { ref, watchEffect } from "vue";
import { Options } from "vue-class-component";
import Base from "../base/Base.vue";
@Options({})
export default class FilterChallenge extends Base {
  public keySearch = "";
  public keyFilter: string[] = [];
  check = false;
  setkeyFilter(type: any) {
    if (type.value) {
      this.keyFilter.push(type.name);
    } else {
      const key = this.keyFilter.findIndex((key: string) => key === type.name);
      this.keyFilter.splice(key, 1);
    }
    this.store.commit(MutationTypes.SET_KEY_FILTER, this.keyFilter);
  }
  created() {
    watchEffect(() => {
      this.store.commit(MutationTypes.SET_KEY_SEARCH, this.keySearch);
    });
  }

  public types = ref([
    {
      name: "1",
      value: false
    },
    {
      name: "3",
      value: false
    },
    {
      name: "5",
      value: false
    },
    {
      name: "10",
      value: false
    }
  ]);
}
